/**
* Use the CSS tab above to style your Element's container.
*/
import React from 'react';
import {CardElement} from '@stripe/react-stripe-js';

const CARD_ELEMENT_OPTIONS = {
  style: {
    base: {
      color: "#374151",
      fontFamily: '"Inter", "Helvetica Neue", Helvetica, sans-serif',
      fontSmoothing: "antialiased",
      fontSize: "clamp(14px, 2.5vw, 16px)",
      "::placeholder": {
        color: "#9CA3AF",
      },
      padding: "clamp(12px, 2vw, 16px)",
      backgroundColor: "white",
    },
    invalid: {
      color: "#DC2626",
      iconColor: "#DC2626",
    },
  },
};

function CardSection() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
      <label style={{
        display: 'block',
        fontSize: 'clamp(0.75rem, 2.5vw, 0.875rem)',
        fontWeight: '500',
        color: '#374151'
      }}>
        Card Details
      </label>
      <div style={{
        border: '1px solid #d1d5db',
        borderRadius: '0.5rem',
        padding: 'clamp(0.5rem, 1.5vw, 0.75rem)',
        backgroundColor: 'white',
        transition: 'all 0.2s ease',
        overflow: 'hidden',
        minHeight: 'clamp(2.5rem, 6vw, 3rem)'
      }}>
        <CardElement 
          options={CARD_ELEMENT_OPTIONS} 
          style={{
            width: '100%',
            minHeight: 'clamp(2rem, 5vw, 2.5rem)'
          }}
        />
      </div>
    </div>
  );
}

export default CardSection;